import {
    ViewEncapsulation,
    Component,
    ElementRef,
    inject,
    input,
    ChangeDetectionStrategy,
    OnInit,
} from '@angular/core';
import { SizeRange } from '@bazis/shared/models/base.types';

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { --margin-start: 0; --margin-end: 0; --margin-top: 0; --margin-bottom: 0; --color: inherit; color: var(--color); margin-left: var(--margin-start); margin-right: var(--margin-end); margin-top: var(--margin-top); margin-bottom: var(--margin-bottom); text-align: left; } :host span { display: inline-block; } bazis-tooltip { --padding-start: var(--bazis-padding-3x); --padding-end: var(--bazis-padding-3x); --padding-top: var(--bazis-padding-3x); --padding-bottom: var(--bazis-padding-3x); --border-radius: var(--bazis-border-radius); --background: var(--bazis-text-color); --color: var(--bazis-text-color-contrast); --min-height: 40px; --min-width: 100px; --max-width: 312px; --font-size: 13px; --font-weight: 400; --line-height: 16px; --height-arrow: 4px; --width-arrow: 12px; z-index: 1000; }`,
);

@Component({
    selector: 'bazis-interrogation',
    templateUrl: './interrogation.component.html',
    // styleUrls: ['interrogation.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class InterrogationElement implements OnInit {
    public el = inject(ElementRef);

    readonly icon = input<string>('interrogation');

    readonly iconSize = input<SizeRange>(SizeRange.mini);

    readonly tooltipText = input<string>();

    // действие которое вызывает тултип, по умолчанию наведение
    readonly tooltipEventType = input<'hover' | 'click'>('hover');

    // расположение тултипа, по умолчанию снизу от начала вызывающего элемента.
    readonly tooltipPlacement = input<
        | 'auto'
        | 'auto-start'
        | 'auto-end'
        | 'top'
        | 'top-start'
        | 'top-end'
        | 'bottom'
        | 'bottom-start'
        | 'bottom-end'
        | 'right'
        | 'right-start'
        | 'right-end'
        | 'left'
        | 'left-start'
        | 'left-end'
    >('bottom-start');

    // смещение тултипа [x, y]
    readonly tooltipOffset = input<[number, number]>([-10, 6]);

    readonly tooltipIsStatic = input<boolean>(true);

    readonly type = input<'dark' | 'light'>('dark');

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
